import React from "react";
import gettingStartedVideo from "../docsAssets/getting_started.mp4";

export default function GettingStarted({ isEN }) {
  return (
    <div>
      <div className="flex items-center mb-8">
        {/* <div className="w-10 h-10 bg-orange-500 rounded-xl flex items-center justify-center mr-4 shadow-lg">
                    <svg
                        className="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                        />
                    </svg>
                </div> */}
        <div>
          <h2 className="text-3xl font-bold text-gray-800 dark:text-white">
            {isEN ? "Getting Started" : "開始使用"}
          </h2>
          <p className="text-gray-500 dark:text-gray-400 mt-1">
            {isEN ? "Your journey begins here" : "您的旅程從這裡開始"}
          </p>
        </div>
      </div>
      <div className="space-y-6">
        <div className="bg-slate-200 dark:bg-gray-900/40 rounded-xl p-8 border border-gray-300 dark:border-gray-700 shadow-lg">
          <div className="flex items-center mb-6">
            <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
              <svg
                className="md:w-5 md:h-5 h-3 w-3 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                />
              </svg>
            </div>
            <h3 className="md:text-2xl text-xl font-bold text-gray-800 dark:text-white">
              {isEN
                ? "Welcome to T-Global Product Information Management System (PIMS)"
                : "歡迎使用 T-Global Product Information System (PIMS)"}
            </h3>
          </div>
          <p className="text-gray-700 dark:text-gray-300 mb-8 md:text-lg text-md leading-relaxed">
            {isEN
              ? "This comprehensive guide will help you get started with the T-Global PIMS. Follow these steps to begin your journey."
              : "這個全面的指南將幫助您開始使用 T-Global PIMS。按照這些步驟開始您的旅程。"}
          </p>

          <div className="space-y-6">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center space-x-3 mb-4">
                {/* <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center shadow-md">
                                    <svg
                                        className="w-5 h-5 text-white"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </div> */}
                <span className="text-gray-600 dark:text-gray-400 font-semibold text-lg">
                  {isEN ? "Step 1:" : "步驟 1:"}
                </span>
              </div>
              <div className="md:ml-11">
                <h4 className="text-gray-800 dark:text-white font-semibold mb-2">
                  {isEN
                    ? "Sign in to your account or create a new one"
                    : "登入您的帳戶或建立新帳戶"}
                </h4>
                <p className="text-gray-600 dark:text-gray-400 text-sm">
                  {isEN
                    ? "(Please sign up with a @tglobalcorp.com, @integrity-tech.com.tw, or @xerendipity.ai email address)"
                    : "（請使用 @tglobalcorp.com、@integrity-tech.com.tw 或 @xerendipity.ai 電子郵件地址註冊）"}
                </p>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center space-x-3 mb-4">
                {/* <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center shadow-md">
                                    <svg
                                        className="w-5 h-5 text-white"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </div> */}
                <span className="text-gray-600 dark:text-gray-400 font-semibold text-lg">
                  {isEN ? "Step 2:" : "步驟 2:"}
                </span>
              </div>
              <div className="ml-11">
                <h4 className="text-gray-800 dark:text-white font-semibold mb-2">
                  {isEN
                    ? "Navigate to the dashboard and explore the interface"
                    : "導航到儀表板並探索介面"}
                </h4>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center space-x-3 mb-4">
                {/* <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center shadow-md">
                                    <svg
                                        className="w-5 h-5 text-white"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </div> */}
                <span className="text-gray-600 dark:text-gray-400 font-semibold text-lg">
                  {isEN ? "Step 3:" : "步驟 3:"}
                </span>
              </div>
              <div className="ml-11">
                <h4 className="text-gray-800 dark:text-white font-semibold mb-2">
                  {isEN
                    ? "Start your first conversation with T-Global PIMS AI agent"
                    : "開始與 T-Global PIMS AI 代理的第一次對話"}
                </h4>
              </div>
            </div>
          </div>

          <div className="mt-8 bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
            <div className="flex items-center mb-4">
              {/* <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
                                <svg
                                    className="w-5 h-5 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293H15"
                                    />
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                            </div> */}
              <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                {isEN ? "Sign Up for New Users" : "新用戶註冊"}
              </h4>
            </div>
            <div className="bg-gray-900 rounded-lg overflow-hidden shadow-inner border border-gray-700">
              <video className="w-fit h-fit object-cover" controls>
                <source src={gettingStartedVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className="flex items-center mt-3 text-blue-600 dark:text-blue-400 text-sm">
              <svg
                className="w-4 h-4 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              {isEN ? "Duration: 0:46" : "時長: 0:46"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
